import axois from "axios";
import { BaseApiService } from "./api-base";
import maObjects from "src/modules/ma/classes/ma_objects";

export class WfApiService extends BaseApiService {
  cache: { [key: string]: any } = {};

  constructor(host: string) {
    super("wf");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  get_app_by_ref(app_ref: any, servises: any = undefined) {
    if (!servises) servises = [];

    const path = `${this.url}/get_app_by_ref`;
    app_ref = maObjects.toRef(app_ref);
    const body = {
      app_ref,
      servises: servises,
      keys: ["name", "env", "url", "sql_db"],
      _var_in: ["servises", "keys"],
      _var_out: ["app"],
    };
    return this.http.post(path, body).then((response) => response.data);
  }

  get_servises_for_app(services: any[]) {
    const f_services: any[] = [];
    for (const key of services) {
      if (!this.cache[key]) f_services.push(key);
    }
    return new Promise((resolve, reject) => {
      const app: { [key: string]: any } = {};
      const fillFromCache = () => {
        for (const key of services) {
          app[key] = this.cache[key];
        }
        resolve(app);
      };
      if (f_services.length) {
        const app_ref = this.settings.app_ref;
        this.get_app_by_ref(app_ref, f_services).then((data) => {
          for (const key in data.app) {
            this.cache[key] = data.app[key];
          }
          fillFromCache();
        });
      } else {
        fillFromCache();
      }
    });
  }

  run_wf(wf_ref: any, state: any) {
    const path = `${this.url}/run_wf`;
    const app_ref = maObjects.toRef(this.app_ref);
    const body = {
      app_ref,
      wf_ref,
      state,
    };
    return this.http.post(path, body).then((response) => response.data);
  }
}
